
/* SARATTI Lookbook V2: activate videos selected by swipe, arrows, or thumbnails */
(function () {
  'use strict';

  function playMedia(item) {
    if (!item) return;
    var deferred = item.querySelector('deferred-media');
    if (!deferred || typeof deferred.loadContent !== 'function') return;
    deferred.loadContent();
    window.setTimeout(function () {
      var video = item.querySelector('video');
      if (video && typeof video.play === 'function') {
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      }
    }, 80);
  }

  function setupGallery(gallery) {
    if (!gallery || gallery.dataset.sarattiV2MediaFix === 'true') return;
    gallery.dataset.sarattiV2MediaFix = 'true';
    var viewer = gallery.querySelector('.media-viewer');
    if (!viewer) return;
    var timer;

    function activateVisible() {
      var items = Array.prototype.filter.call(viewer.querySelectorAll('.media-viewer__item'), function (item) {
        return item.offsetParent !== null;
      });
      if (!items.length) return;
      var center = viewer.scrollLeft + (viewer.clientWidth / 2);
      var active = items[0];
      var distance = Infinity;
      items.forEach(function (item) {
        var itemCenter = item.offsetLeft + (item.offsetWidth / 2);
        var nextDistance = Math.abs(itemCenter - center);
        if (nextDistance < distance) { active = item; distance = nextDistance; }
      });
      playMedia(active);
    }

    viewer.addEventListener('scroll', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(activateVisible, 120);
    }, { passive: true });

    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('.media-thumbs [data-media-id]');
      if (thumb) {
        var item = viewer.querySelector('[data-media-id="' + thumb.dataset.mediaId + '"]');
        window.setTimeout(function () { playMedia(item); }, 0);
        return;
      }
      if (event.target.closest('.media-ctrl__btn')) window.setTimeout(activateVisible, 350);
    });
  }

  function boot() {
    document.querySelectorAll('.saratti-lookbook-product-section media-gallery').forEach(setupGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
(function(){
  function qs(selector, root){ return (root || document).querySelector(selector); }
  function qsa(selector, root){ return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  function bootContactAndInquiry(){
    var trigger = qs('.saratti-lb-inquiry');
    var generalTrigger = qs('[data-saratti-general-enquiry]');
    var purchaseTrigger = qs('[data-saratti-purchase-request]');
    var overlay = qs('[data-saratti-v2-overlay]');
    var contactPanel = qs('[data-saratti-contact-panel]');
    var enquiryPanel = qs('[data-saratti-v2-panel]');
    var closeButtons = qsa('[data-saratti-v2-close]');
    var openFormButtons = qsa('[data-saratti-open-form]');
    var backButtons = qsa('[data-saratti-contact-back]');
    var tidioButtons = qsa('[data-saratti-tidio]');
    var form = document.getElementById('saratti-v2-enquiry-form');
    var formWrap = qs('[data-saratti-v2-form-wrap]');
    var success = qs('[data-saratti-v2-success]');
    var successTitle = qs('[data-saratti-v2-success-title]');
    var successCopy = qs('[data-saratti-v2-success-copy]');
    var submit = qs('[data-saratti-v2-submit]');
    var submitError = qs('[data-saratti-v2-submit-error]');
    var panelTitle = document.getElementById('saratti-v2-panel-title');
    var panelSubtitle = qs('.saratti-v2-panel__subtitle', enquiryPanel);
    var titleField = qs('[data-saratti-title-field]');
    var titleSelect = document.getElementById('saratti-v2-title');
    var phone = document.getElementById('saratti-v2-phone');
    var phoneLabel = document.getElementById('saratti-v2-phone-label');
    var phoneError = document.getElementById('saratti-v2-error-phone');
    var message = document.getElementById('saratti-v2-message');
    var messageLabel = document.getElementById('saratti-v2-message-label');
    var requestType = document.getElementById('saratti-v2-request-type');
    var variantTitle = document.getElementById('saratti-v2-variant-title');
    var variantId = document.getElementById('saratti-v2-variant-id');
    var variantsData = qs('[data-saratti-v2-variants]');
    var activeTrigger = null;
    var variants = [];

    if(!overlay || !contactPanel || !enquiryPanel) return;

    if(variantsData){
      try{
        variants = JSON.parse(variantsData.textContent || '[]');
      }catch(error){
        variants = [];
      }
    }

    function mode(){
      return enquiryPanel.getAttribute('data-saratti-enquiry-mode') || 'general';
    }

    function bodyLock(lock){
      document.body.style.overflow = lock ? 'hidden' : '';
    }

    function clearErrors(){
      qsa('.saratti-v2-error', form).forEach(function(error){
        error.style.display = 'none';
      });
      qsa('input, select, textarea', form).forEach(function(field){
        field.style.borderBottomColor = '';
      });
      if(submitError) submitError.hidden = true;
    }

    function setSubmitReady(){
      if(!submit) return;
      submit.disabled = false;
      submit.textContent = mode() === 'purchase' ? 'SUBMIT PURCHASE ENQUIRY' : 'Submit';
    }

    function closeAll(){
      overlay.classList.remove('is-open');
      contactPanel.classList.remove('is-open');
      enquiryPanel.classList.remove('is-open');
      contactPanel.setAttribute('aria-hidden','true');
      enquiryPanel.setAttribute('aria-hidden','true');
      bodyLock(false);

      if(activeTrigger && document.contains(activeTrigger)){
        activeTrigger.focus();
      }
    }

    function resetFormView(){
      if(success) success.style.display = 'none';
      if(formWrap) formWrap.style.display = 'block';
      if(form) form.reset();
      clearErrors();
      setSubmitReady();
    }

    function selectedVariantId(){
      var productForm = qs('.js-product-form-main');
      var input = productForm ? qs('input[name="id"]', productForm) : null;
      return input ? String(input.value || '') : '';
    }

    function syncVariant(){
      var id = selectedVariantId();
      if(variantId) variantId.value = id;

      if(variantTitle){
        var found = variants.find(function(variant){
          return String(variant.id) === id;
        });
        variantTitle.value = found ? found.title : '';
      }
    }

    function applyMode(nextMode){
      var purchaseMode = nextMode === 'purchase';

      enquiryPanel.setAttribute('data-saratti-enquiry-mode', nextMode);

      if(panelTitle){
        panelTitle.textContent = purchaseMode ? 'Private Purchase Enquiry' : 'Privé Enquiry';
      }

      if(panelSubtitle){
        panelSubtitle.textContent = purchaseMode
          ? 'Please share your details below. A SARATTI client advisor will confirm current availability and contact you personally to arrange your purchase.'
          : 'Complete the form below and a SARATTI specialist will personally assist you.';
      }

      if(titleField){
        titleField.hidden = purchaseMode;
      }

      if(titleSelect){
        titleSelect.required = !purchaseMode;
        if(purchaseMode) titleSelect.value = '';
      }

      if(phone){
        phone.required = purchaseMode;
      }

      if(phoneLabel){
        phoneLabel.innerHTML = purchaseMode
          ? 'Phone / WhatsApp <span class="req">*</span>'
          : 'Phone Number <span class="opt">(Optional)</span>';
      }

      if(messageLabel){
        messageLabel.innerHTML = purchaseMode
          ? 'Purchase Request <span class="req">*</span>'
          : 'Your Enquiry <span class="req">*</span>';
      }

      if(message){
        message.placeholder = purchaseMode
          ? ''
          : 'Kindly let us know what you would like to enquire about concerning this piece.';
        message.value = purchaseMode
          ? 'I would like to purchase this piece. Kindly confirm its current availability and contact me with the next steps.'
          : '';
        message.dispatchEvent(new Event('input', { bubbles: true }));
      }

      if(requestType){
        requestType.value = purchaseMode ? 'Purchase Request' : 'General Enquiry';
      }

      syncVariant();
      setSubmitReady();
    }

    function openContact(event){
      if(event){
        event.preventDefault();
        activeTrigger = event.currentTarget || activeTrigger;
      }

      enquiryPanel.classList.remove('is-open');
      enquiryPanel.setAttribute('aria-hidden','true');
      overlay.classList.add('is-open');
      contactPanel.classList.add('is-open');
      contactPanel.removeAttribute('aria-hidden');
      bodyLock(true);
    }

    function openEnquiry(nextMode, event){
      if(event){
        event.preventDefault();
        activeTrigger = event.currentTarget || activeTrigger;
      }

      resetFormView();
      applyMode(nextMode);

      contactPanel.classList.remove('is-open');
      contactPanel.setAttribute('aria-hidden','true');
      overlay.classList.add('is-open');
      enquiryPanel.classList.add('is-open');
      enquiryPanel.removeAttribute('aria-hidden');
      bodyLock(true);

      window.setTimeout(function(){
        var first = nextMode === 'purchase'
          ? document.getElementById('saratti-v2-first')
          : document.getElementById('saratti-v2-title');
        if(first) first.focus();
      }, 80);
    }

    function openGeneralEnquiry(event){
      openEnquiry('general', event);
    }

    function openPurchaseEnquiry(event){
      if(event){
        event.preventDefault();
        event.stopPropagation();
      }
      openEnquiry('purchase', event);
    }

    function handleBack(event){
      if(mode() === 'purchase'){
        if(event) event.preventDefault();
        closeAll();
        return;
      }
      openContact(event);
    }

    function openTidio(event){
      if(event) event.preventDefault();
      closeAll();

      function open(){
        if(window.tidioChatApi && typeof window.tidioChatApi.open === 'function'){
          window.tidioChatApi.open();
          return true;
        }
        return false;
      }

      if(open()) return;

      var opened = false;
      var ready = function(){
        if(opened) return;
        opened = open();
      };

      document.addEventListener('tidioChat-ready', ready, { once: true });
      window.setTimeout(ready, 700);
      window.setTimeout(ready, 1600);
    }

    if(generalTrigger && generalTrigger.getAttribute('data-saratti-general-bound') !== 'true'){
      generalTrigger.setAttribute('data-saratti-general-bound','true');
      generalTrigger.addEventListener('click', openGeneralEnquiry);
    }else if(trigger && trigger.getAttribute('data-saratti-contact-bound') !== 'true'){
      trigger.setAttribute('data-saratti-contact-bound','true');
      trigger.addEventListener('click', openContact);
    }

    if(purchaseTrigger && purchaseTrigger.getAttribute('data-saratti-purchase-bound') !== 'true'){
      purchaseTrigger.setAttribute('data-saratti-purchase-bound','true');
      purchaseTrigger.addEventListener('click', openPurchaseEnquiry, true);
    }

    overlay.onclick = closeAll;

    closeButtons.forEach(function(button){
      if(button.getAttribute('data-saratti-close-bound') === 'true') return;
      button.setAttribute('data-saratti-close-bound','true');
      button.addEventListener('click', closeAll);
    });

    openFormButtons.forEach(function(button){
      if(button.getAttribute('data-saratti-form-bound') === 'true') return;
      button.setAttribute('data-saratti-form-bound','true');
      button.addEventListener('click', openGeneralEnquiry);
    });

    backButtons.forEach(function(button){
      if(button.getAttribute('data-saratti-back-bound') === 'true') return;
      button.setAttribute('data-saratti-back-bound','true');
      button.addEventListener('click', handleBack);
    });

    tidioButtons.forEach(function(button){
      if(button.getAttribute('data-saratti-tidio-bound') === 'true') return;
      button.setAttribute('data-saratti-tidio-bound','true');
      button.addEventListener('click', openTidio);
    });

    if(!window.__sarattiV2EscapeBound){
      window.__sarattiV2EscapeBound = true;
      document.addEventListener('keydown', function(event){
        if(event.key !== 'Escape') return;
        var currentContact = qs('[data-saratti-contact-panel]');
        var currentEnquiry = qs('[data-saratti-v2-panel]');
        if(
          currentContact && currentContact.classList.contains('is-open') ||
          currentEnquiry && currentEnquiry.classList.contains('is-open')
        ){
          var currentOverlay = qs('[data-saratti-v2-overlay]');
          if(currentOverlay) currentOverlay.click();
        }
      });
    }

    function validateField(id, errorId, test){
      var field = document.getElementById(id);
      var error = document.getElementById(errorId);
      if(!field || !error) return true;
      var bad = !test(field);
      error.style.display = bad ? 'block' : 'none';
      field.style.borderBottomColor = bad ? '#c00' : '';
      return !bad;
    }

    function validate(){
      var ok = true;

      if(mode() !== 'purchase'){
        ok = validateField('saratti-v2-title','saratti-v2-error-title',function(field){
          return field.value !== '';
        }) && ok;
      }

      ok = validateField('saratti-v2-first','saratti-v2-error-first',function(field){
        return field.value.trim() !== '';
      }) && ok;

      ok = validateField('saratti-v2-last','saratti-v2-error-last',function(field){
        return field.value.trim() !== '';
      }) && ok;

      ok = validateField('saratti-v2-email','saratti-v2-error-email',function(field){
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim());
      }) && ok;

      if(phone && phone.required){
        ok = validateField('saratti-v2-phone','saratti-v2-error-phone',function(field){
          return field.value.trim() !== '';
        }) && ok;
      }else if(phoneError){
        phoneError.style.display = 'none';
      }

      ok = validateField('saratti-v2-message','saratti-v2-error-message',function(field){
        return field.value.trim() !== '';
      }) && ok;

      return ok;
    }

    function showSuccess(){
      var purchaseMode = mode() === 'purchase';

      if(successTitle){
        successTitle.textContent = purchaseMode
          ? 'Your purchase request has been received.'
          : 'Your enquiry has been received.';
      }

      if(successCopy){
        successCopy.textContent = purchaseMode
          ? 'A SARATTI client advisor will confirm current availability and contact you personally.'
          : 'A SARATTI concierge will personally assist you shortly.';
      }

      if(formWrap) formWrap.style.display = 'none';
      if(success) success.style.display = 'flex';
      enquiryPanel.scrollTop = 0;
    }

    function showSubmitError(){
      if(submitError) submitError.hidden = false;
      setSubmitReady();
    }

    if(form && form.getAttribute('data-saratti-form-submit-bound') !== 'true'){
      form.setAttribute('data-saratti-form-submit-bound','true');

      form.addEventListener('input', function(event){
        if(submitError) submitError.hidden = true;
        if(event.target && event.target.style){
          event.target.style.borderBottomColor = '';
        }
      });

      form.addEventListener('submit', function(event){
        event.preventDefault();
        clearErrors();
        if(!validate()) return;

        syncVariant();

        if(submit){
          submit.textContent = 'Sending...';
          submit.disabled = true;
        }

        var action = form.getAttribute('action') || '/contact';
        var params = new URLSearchParams(new FormData(form)).toString();

        fetch(action, {
          method: 'POST',
          body: params,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function(response){
          if(!response.ok || response.status >= 400){
            throw new Error('Request failed');
          }
          if(response.redirected && /challenge|captcha/i.test(response.url || '')){
            throw new Error('Challenge required');
          }
          showSuccess();
        })
        .catch(showSubmitError);
      });
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootContactAndInquiry);
  }else{
    bootContactAndInquiry();
  }

  document.addEventListener('shopify:section:load', bootContactAndInquiry);
})();